:host {
  --ch-virtual-scroll__scroll-start-size: 0px;
  --ch-virtual-scroll__scroll-end-size: 0px;

  --ch-virtual-scroll__scroll-start-display: none;
  --ch-virtual-scroll__scroll-end-display: none;

  display: grid;
  grid-auto-rows: max-content;
}

:host(.ch-virtual-scroller--content-not-loaded) {
  opacity: 0;
  // Necessary to ensure the scroll is positioned correctly when using inverseLoading
  pointer-events: none;
}

// This is an optimization to avoid flickering when swapping cell.
// With this CSS, cells being rendered do not take up space until they are
// fully rendered. When they are fully rendered, we make the cells take up
// space and in the same DOM write operation we update the virtual scroll size
:host(.ch-virtual-scroller--content-loaded)
  ::slotted(ch-smart-grid-cell:not([data-did-load])) {
  position: absolute;
  pointer-events: none;
  visibility: hidden;
}

:host(.ch-virtual-scroller--virtual-scroll) {
  &::before {
    content: "";
    display: var(--ch-virtual-scroll__scroll-start-display);
    block-size: calc(var(--ch-virtual-scroll__scroll-start-size));
    inline-size: 0px;
    pointer-events: none;
  }

  &::after {
    content: "";
    display: var(--ch-virtual-scroll__scroll-end-display);
    block-size: calc(var(--ch-virtual-scroll__scroll-end-size));
    inline-size: 0px;
    pointer-events: none;
  }
}
